export default "__VITE_ASSET__Bv3a2HdY__"